export default __webpack_public_path__ + "images/4a02279af52716d012edcc00b12a2008.svg";